// Settings modal
import { API_BASE, currentLayout } from './state.js';
import { escapeHtml, showToast } from './utils.js';
import { loadStories } from './stories.js';
import { renderReadingHistory } from './history.js';
import { loadEmailStatus } from './email.js';

export async function openSettings() {
  document.getElementById('settings-modal').classList.add('active');
  await loadSettings();
  document.querySelectorAll('input[name="layout"]').forEach(radio => {
    radio.checked = radio.value === currentLayout;
  });
}

export function closeSettings() {
  document.getElementById('settings-modal').classList.remove('active');
}

async function loadSettings() {
  try {
    const [statsRes, blockedRes, historyRes] = await Promise.all([
      fetch(`${API_BASE}/stats`),
      fetch(`${API_BASE}/blocked`),
      fetch(`${API_BASE}/history?limit=30`)
    ]);

    const stats = await statsRes.json();
    const blocked = await blockedRes.json();
    const historyData = await historyRes.json();

    document.getElementById('stats-grid').innerHTML = `
      <div class="stat-card"><div class="stat-value">${stats.likes}</div><div class="stat-label">Likes</div></div>
      <div class="stat-card"><div class="stat-value">${stats.dislikes}</div><div class="stat-label">Dislikes</div></div>
      <div class="stat-card"><div class="stat-value">${stats.blocks}</div><div class="stat-label">Blocked</div></div>
    `;

    const blockedList = document.getElementById('blocked-list');
    if (blocked.length === 0) {
      blockedList.innerHTML = '<span class="empty-state">No blocked items yet.</span>';
    } else {
      blockedList.innerHTML = blocked.map(item => `
        <div class="blocked-item">
          <span class="blocked-item-type">${item.type}</span>
          <span class="blocked-item-value">${escapeHtml(item.value)}</span>
          <button class="blocked-item-remove" onclick="window.appUnblockItem('${item.type}', '${escapeHtml(item.value)}')">&times;</button>
        </div>
      `).join('');
    }

    const topTopics = document.getElementById('top-topics');
    if (stats.topTopics.length === 0) {
      topTopics.innerHTML = '<span class="empty-state">Like some stories to see your top topics.</span>';
    } else {
      topTopics.innerHTML = stats.topTopics.map(t => `
        <span class="topic-tag">${escapeHtml(t.topic)}<span class="topic-weight">${t.weight}</span></span>
      `).join('');
    }

    renderReadingHistory(historyData.history || []);
    loadEmailStatus();
  } catch (error) {
    console.error('Failed to load settings:', error);
  }
}

export async function unblockItem(type, value) {
  try {
    const response = await fetch(`${API_BASE}/blocked`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ type, value })
    });
    if (!response.ok) throw new Error('Server error');
    showToast(`Unblocked: ${value}`);
    await loadSettings();
    const { currentCategory } = await import('./state.js');
    loadStories(currentCategory);
  } catch (error) {
    console.error('Failed to unblock:', error);
    showToast('Failed to unblock', 'error');
  }
}
